import { DATES } from "@/data/content";
import Reveal from "@/components/Reveal";

export default function ImportantDates() {
  return (
    <section id="dates" className="py-24 sm:py-32 px-5 sm:px-8 lg:px-12 bg-ink text-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <Reveal>
              <p className="font-mono text-xs uppercase tracking-[0.22em] text-crimson font-semibold mb-5">05 · Important Dates</p>
              <h2 className="font-heading text-4xl sm:text-5xl font-bold tracking-tighter leading-[0.95]">
                Mark your calendar.
              </h2>
              <p className="mt-5 text-white/60 leading-relaxed">Lock in the deadlines below. Early-bird registration saves you the most.</p>
            </Reveal>
          </div>

          <div className="lg:col-span-8">
            <div className="relative pl-8 border-l border-white/15">
              {DATES.map((d, i) => (
                <Reveal key={d.event} delay={i * 0.06}>
                  <div className="relative pb-10 last:pb-0 group">
                    <span className="absolute -left-[37px] top-1.5 w-3 h-3 rounded-full bg-crimson ring-4 ring-ink group-hover:scale-125 transition-transform" />
                    <div className="flex flex-col sm:flex-row sm:items-baseline sm:justify-between gap-1">
                      <h3 className="font-heading text-xl sm:text-2xl font-medium tracking-tight">{d.event}</h3>
                      <span className="font-mono text-sm text-crimson font-semibold whitespace-nowrap">{d.date}</span>
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
